module.exports = __webpack_public_path__ + "../front/img/368bøjestang+3hylder.bc48848d.svg";